
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { SingleTableModel, LastEvaluatedKey} from '../models/singleTableModel';
import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class TenantsService {

  pageData: any = [];
  constructor(private http: HttpClient, private authService: AuthService) {
  }
  
  headers = {
    'Authorization': this.authService.Authorization$.value,
    //'LoggedInUserAccessKey': this.authService.AccessDetails$.value.AccessKey
  };
  httpOptions = {
    headers: this.headers
  };

  setheader() {
    this.headers.Authorization = this.authService.Authorization$.value;
    //this.headers.LoggedInUserAccessKey = this.authService.AccessDetails$.value.AccessKey;
    this.httpOptions.headers = this.headers;
  }
  
  
  getAllTenants(): Observable<any> {
    this.setheader();
    return this.http.get(environment.tenantsURL.replace('#hostname#', this.authService.hostName$.value) + '/getAllTenants', { 'headers': this.headers } );
  }

  getUserTenants(accessAssociation: string): Observable<any> {
    this.setheader();
    var params = new HttpParams()
      .set("accessAssociation", accessAssociation)
      .set("methodId", 'getUserTenants')
    return this.http.get(environment.tenantsURL.replace('#hostname#', this.authService.hostName$.value), { 'params': params, 'headers': this.headers });
  }

  getAllTenantsWithLimit(accessKey: string, limit: number, lekTenantId: string, lekTransactionId: string): Observable<any> {
    this.setheader();
    var tenants = {};
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    var params = new HttpParams()
      .set("limit", limit)
      .set("lekTenantId", lekTenantId)
      .set("lekTransactionId", lekTransactionId)
      .set("methodId", 'getAllTenantsWithLimit')

    return this.http.get(environment.tenantsURL.replace('#hostname#', this.authService.hostName$.value)+'/getAllTenants', { 'params': params, 'headers': this.headers });
  }

  getTenant(tenantId: string, accessKey: string): Observable<any> {
    this.setheader();
    var params = new HttpParams()
      .set("accessKey", accessKey)
      .set("methodId", 'getTenant')
      .set("tenantId", 'getTenant');
    return this.http.get(environment.tenantsURL.replace('#hostname#', this.authService.hostName$.value) + '/getTenant', { 'params': params, 'headers': this.headers });
  }

  createTenant(tenant: SingleTableModel): Observable<any> {    
    this.setheader();
    tenant.updateBy = localStorage.getItem('UserName') ?? '';
    return this.http.post(environment.tenantsURL.replace('#hostname#', this.authService.hostName$.value) +'/addTenant',tenant, this.httpOptions);
  }

  updateTenant(tenant: SingleTableModel): Observable<any> {
    this.setheader();
    tenant.updateBy = localStorage.getItem('UserName') ?? '';
    return this.http.put(environment.tenantsURL.replace('#hostname#', this.authService.hostName$.value) + '/updateTenantName', tenant, this.httpOptions);
  }

  disableTenant(tenant: SingleTableModel): Observable<any> {
    this.setheader();
    tenant.updateBy = localStorage.getItem('UserName') ?? '';
    return this.http.put(environment.tenantsURL.replace('#hostname#', this.authService.hostName$.value) + '/updateIsActive', tenant, this.httpOptions);
  }

  deleteTenant(accessKey: string, tenantId: string): Observable<any> {
    this.setheader();
    var params = new HttpParams()
      .set("accessKey", accessKey)
      .set("tenantId", tenantId);
    return this.http.delete(environment.tenantsURL.replace('#hostname#', this.authService.hostName$.value) +'/deleteTenant', { 'params': params, 'headers': this.headers });
  }

}
